import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {Datapoint} from '@deviceinsight/ng-ui-api-client';
import {ReactableColumnDef} from '@deviceinsight/ng-ui-components';
import DatapointTrans, {translateDatapoint} from './DatapointTrans';
import {TFunction, TranslationDescriptor} from '@deviceinsight/ng-ui-scale-lib/api';

const DATA_TYPE_INFOS: Array<{
	value: string;
	label: TranslationDescriptor;
}> = [
	{
		value: 'DOUBLE',
		label: {
			id: 'general.dp.decimal',
			defaultValue: 'Decimal'
		}
	},
	{
		value: 'LONG',
		label: {
			id: 'general.dp.integer',
			defaultValue: 'Integer'
		}
	},
	{
		value: 'BOOLEAN',
		label: {
			id: 'general.dp.boolean',
			defaultValue: 'Boolean'
		}
	},
	{
		value: 'TEXT',
		label: {
			id: 'general.dp.text',
			defaultValue: 'Text'
		}
	},
	{
		value: 'GEO_POSITION',
		label: {
			id: 'general.dp.geo_position',
			defaultValue: 'Geographical position'
		}
	}
];
export const DEFAULT_SELECTABLE_DATATYPES = ['BOOLEAN', 'LONG', 'DOUBLE', 'TEXT'];
export const getColumnDefs = (
	t: TFunction,
	onClick: (datapoint: Datapoint) => any,
	columnDatatypeWidth = '*',
	availableDataTypes: Array<string> = DEFAULT_SELECTABLE_DATATYPES
): Array<ReactableColumnDef<Datapoint>> => {
	const filterableDataTypes = DATA_TYPE_INFOS.filter((dataTypeInfo) =>
		availableDataTypes.includes(dataTypeInfo.value)
	);
	return [
		{
			name: 'name',
			label: {
				id: 'datapoint.name',
				defaultValue: 'Name'
			},
			width: '20%',
			sortable: true,
			filterable: {
				filterType: 'text',
				filterFn: (dp: Datapoint, value: string) =>
					translateDatapoint(dp, t).toLowerCase().indexOf(value.toLowerCase()) >= 0
			},
			render: (dp) => <DatapointTrans datapoint={dp} />,
			onClick
		},
		{
			name: 'unit',
			label: {
				id: 'datapoint.unit',
				defaultValue: 'Unit'
			},
			width: '10%',
			sortable: false,
			filterable: {
				filterType: 'text',
				filterFn: (dp: Datapoint, value: string) =>
					!!dp.unit && !!dp.unit.print && dp.unit.print.toLowerCase().indexOf(value.toLowerCase()) === 0
			},
			render: (dp) => (dp.unit ? dp.unit.print : '-'),
			onClick
		},
		{
			name: 'datatype',
			label: {
				id: 'datapoint.dataType',
				defaultValue: 'Data Type'
			},
			width: columnDatatypeWidth,
			sortable: false,
			filterable: {
				filterType: 'options',
				// $FlowIgnore - flow should handle this, but it does not anymore... the flow definition of filterOptions is: Array<{value: string, label: string | TranslationDescriptor}>,
				filterOptions: filterableDataTypes,
				filterFn: (dp: Datapoint, value: string) => dp.datatype === value
			},
			render: (dp) => {
				const dataType = filterableDataTypes.find((dataType) => dataType.value === dp.datatype);
				return dataType && dataType.label ? (
					<Trans i18nKey={dataType.label.id}>{dataType.label.defaultValue}</Trans>
				) : null;
			},
			onClick
		}
	];
};
